import { Layout, Button, Modal, Progress, Input, message } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideNavBar from "../../Components/SideBar/Sidebar";
import "../Dashboard/Dashboard.css";
import UserDashboard from "../../Components/UserTasks/UserDashboard";
import PieChart from "../../Components/PieChart/PieChart";
import MarqueeHeader from "../../Components/Marquee/Marquee";
import { PlusCircleOutlined, CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import Navbar from "../../Components/Support/Header";
import Cookies from "js-cookie";
import axios from 'axios';
import { Redirect } from "react-router-dom";
import { loadUpdates, addUpdate, callNotifications } from "../../redux/DashboardRedux/DashboardActions";

const { Header, Content } = Layout;
const { TextArea } = Input;
const Dashboard = () => {

  const [showAddPopup, setShowAddPopup] = useState(false);
  const [content, setContent] = useState('')
  var currentdate = new Date();

  const payrollUpdates = useSelector(state => state.dashboardreducer.updates)
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const firstName = Cookies.get("first_name");
  const lastName = Cookies.get("last_name");
  const [approvalLoading, setApprovalLoading] = useState(false)
  const [errorMSG, showErrorMSG] = useState(false);
  const [groupPer, setGroupPer] = useState([])
  const [messageApi, contextHolder] = message.useMessage();
  const [displayCycle, setDisplayCycle] = useState(1);

  var Call = 0;
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(loadUpdates())
    if (Call === 0) {
      Call = 1;
      callTaskStatusPercentage()
    }
  }, [])

  const Groups = ["Newhires/Rehires", "Payroll Timecards", "Payroll Masterfile", "Payroll Adjustments", "Payroll Export/.CSV"];
  const callTaskStatusPercentage = async () => {
    setGroupPer([])
    groupPer.length = 0;
    let i = 0;
    for (i = 0; i < Groups.length; i++) {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}UserTask/GetPercentage?groupname=` + Groups[i],
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          }
        },

      )
      groupPer.push(res.data)
      setGroupPer([...groupPer], res.data)
    }
  }

  const openAddUpdatePopup = () => {
    setShowAddPopup(true)
  }
  const sendForApproval = async () => {
    if (content !== '') {
      setApprovalLoading(true)
      const response = await dispatch(addUpdate(content, currentdate))
      setApprovalLoading(false)
      setContent('')
      setShowAddPopup(false)
      if (response.data !== 'payroll update is posted successfully') {
        setTimeout(() => {
          failure()
        }, 1000);
      }
      else { dispatch(callNotifications()) }
    }
    else {
      showErrorMSG(true)
    }
  }
  const failure = () => {
    messageApi.open({
      type: 'error',
      content: 'Cannot add update',
    });
  };
  const closeAddUpdatePopup = () => {
    setShowAddPopup(false)
    showErrorMSG(false)
    setContent('')
  }

  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  return (

    <div >
      <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
        <SideNavBar />
        <Layout className="whole-div">
          <Header className="whole-header-class">
            <MarqueeHeader />
            <Navbar />
          </Header>
          <Content className="dashboard-content">
            <div className="chart-cards-row">
              <div className="chart-row">
                <PieChart />
              </div>
              <div className="cards-row">
                {displayCycle === 1 ? 
                <div className="cards-inside-row">
                  <div className="cycle-change-arrow">
                    <CaretLeftOutlined style={{ fontSize: 18.58, color:"rgba(217, 217, 217, 1)" }} /><span className="cycle-heading">&nbsp;Regular Payroll&nbsp;&nbsp;</span>
                    <CaretRightOutlined style={{ fontSize: 18.58, cursor: "pointer" }} onClick={() => setDisplayCycle(2)}/>
                  </div>
                  <div className="cards-second-row">
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[0]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>New hires/ Rehires</div>
                    </div>
                    <div className="inside-cards">

                      <Progress type="circle" percent={parseFloat(groupPer[0]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Health Insurance</div>
                    </div>
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[0]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Garnishments</div>
                    </div>
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[1]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Timecards</div>
                    </div>
                  </div>
                  <div className="cards-first-row">
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[2]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Payroll Masterfile</div>
                    </div>
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[3]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Payroll Adjustments</div>
                    </div>
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[0]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Payroll audit review</div>
                    </div>
                    <div className="inside-cards">
                      <Progress type="circle" percent={parseFloat(groupPer[4]).toFixed(0)} size={35}
                        strokeColor={'rgba(0, 80, 179, 0.4)'}
                        trailColor="#e0e4eb"
                        className="progress-circle" />
                      <div>Payroll Export/ .CSV</div>
                    </div>
                  </div>
                </div> : displayCycle === 2 ? 
                <div className="cards-inside-row">
                <div className="cycle-change-arrow">
                  <CaretLeftOutlined style={{ fontSize: 18.58, cursor: "pointer"}} onClick={() => setDisplayCycle(1)}/><span className="cycle-heading">&nbsp;Off Cycle Payroll&nbsp;&nbsp;</span>
                  <CaretRightOutlined style={{ fontSize: 18.58, cursor: "pointer" }} onClick={() => setDisplayCycle(3)}/>
                </div>
                <div className="cards-new-row">
                  <div className="inside-cards">
                    <Progress type="circle" percent={30} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>Late Submission</div>
                  </div>
                  <div className="inside-cards">

                    <Progress type="circle" percent={20} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>Commisions</div>
                  </div>
                  <div className="inside-cards">
                    <Progress type="circle" percent={10} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>Bonuses</div>
                  </div>
                  <div className="inside-cards">
                    <Progress type="circle" percent={65} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>Exception Pay</div>
                  </div>
                </div>
                {/* <div className="cards-first-row"> */}
                
                  {/* <div className="inside-cards">
                    <Progress type="circle" percent={90} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>----------</div>
                  </div>
                  <div className="inside-cards">
                    <Progress type="circle" percent={90} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>----------</div>
                  </div> */}
                {/* </div> */}
              </div> : <div className="cards-inside-row">
                <div className="cycle-change-arrow">
                  <CaretLeftOutlined style={{ fontSize: 18.58, cursor: "pointer"}} onClick={() => setDisplayCycle(2)}/>
                  <span className="cycle-heading">&nbsp;Expenses Management&nbsp;&nbsp;</span>
                  <CaretRightOutlined style={{ fontSize: 18.58,  color:"rgba(217, 217, 217, 1)" }} />
                </div>
                <div className="expenses-cards-row">
                  <div className="expense-inside-cards">
                    <Progress type="circle" percent={50} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>Contingent Expenses</div>
                  </div>
                  <div className="expense-inside-cards">
                    <Progress type="circle" percent={30} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>Corporate Expenses</div>
                  </div>
                </div>
              </div>}
              </div>
            </div>

            <div className="calender-updates">
              <div className="userdashboard">
                <UserDashboard />
              </div>
              <div className="updates-displaying">
                <div className="payrollupdates-class">
                  <div className="heading-wholediv">
                    <div className="payroll-heading">
                      Payroll Updates
                      <span onClick={openAddUpdatePopup} style={{ cursor: 'pointer' }} className="plus-icon-class"><PlusCircleOutlined /></span>
                      {contextHolder}
                      <Modal
                        open={showAddPopup}
                        className="modalStyle"
                        style={{
                          marginLeft: '71%',
                          marginTop: '8%',
                          maxWidth: '25%',
                        }}
                        footer={false}
                        onOk={openAddUpdatePopup}
                        onCancel={closeAddUpdatePopup}
                      >
                        <div className="footer-textarea">
                          <TextArea
                            id="textbox"
                            allowClear
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            onClick={() => showErrorMSG(false)}
                            style={{ border: 'none', width: '94%' }}
                            autoSize={{
                              minRows: 4,
                              maxRows: 6,
                            }}
                            placeholder="Enter the text here"
                          />
                          <div className="approval-class">
                            <Button className="approval-button" loading={approvalLoading} onClick={sendForApproval}>Send for approval</Button>
                          </div>
                          {
                            errorMSG && <div className="errormsg-class">
                              *Please enter text
                            </div>
                          }
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div className="all-updates">
                    {
                      payrollUpdates ? payrollUpdates.map((item, index) => {
                        return (
                          <div className="render-update">
                            <li className="bullet-list"></li>
                            <p className="paragraph-class" key={index}>{item.Description}</p>
                          </div>
                        )
                      }
                      ) : <div></div>
                    }
                  </div>
                </div>
              </div>

            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
export default Dashboard;